import axiosInstance from "./axiosInstance";
const apiUrl = process.env.REACT_APP_API_URL;

export const createDepartment = async (payload) => {
  try {
    const response = await axiosInstance.post(
      "api/create-department/",
      payload
    );

    return {
      success: true,
      data: response.data,
      status: response.status,
    };

  } catch (error) {
    return {
      success: false,
      message:
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        "Failed to create department",
      errors: error?.response?.data?.errors || null,
      status: error?.response?.status,
    };
  }
};

export const getDepartments = async () => {
  try {
    const response = await axiosInstance.get(
      "api/get-departments/"
    );

    return {
      success: true,
      data: response.data,
      status: response.status,
    };

  } catch (error) {
    return {
      success: false,
      message:
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        "Failed to fetch departments",
      status: error?.response?.status,
    };
  }
};

export const updateDepartment = async (departmentId, payload) => {
  try {
    const response = await axiosInstance.put(
      `api/update-department/${departmentId}/`,
      payload
    );

    return {
      success: true,
      data: response.data,
      status: response.status,
    };

  } catch (error) {
    return {
      success: false,
      message:
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        "Failed to update department",
      errors: error?.response?.data?.errors || null,
      status: error?.response?.status,
    };
  }
};

export const deleteDepartment = async (departmentId) => {
  try {
    const response = await axiosInstance.delete(
      `api/delete-department/${departmentId}/`
    );

    return {
      success: true,
      data: response.data,
      status: response.status,
    };

  } catch (error) {
    return {
      success: false,
      message:
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        "Failed to delete department",
      status: error?.response?.status,
    };
  }
};

export const getDepartmentsByCustomerId = async (customerId) => {
  try {
    const response = await axiosInstance.get(
      `get-departments-customer/${customerId}/`
    );

    return {
      success: true,
      data: response.data,
      status: response.status,
    };

  } catch (error) {
    return {
      success: false,
      message:
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        "Failed to fetch departments",
      status: error?.response?.status,
    };
  }
};
